import { mapActions, mapState } from 'vuex';
import NavigationMixin from './navigation';
import { authService, authStorageService } from '../services/service-factory';
import { ROLES } from '../../../../constants';

export default {
  props: {
    checkAuthInterval: {
      type: Number,
      default: 5000,
    },
  },
  mixins: [NavigationMixin],
  data: function () {
    return {
      authService: undefined,
      authCheckTimer: undefined,
    };
  },
  computed: {
    ...mapState({
      isAuthenticated: (state) => state.user.isAuthenticated,
      isSuperadmin: (state) => state.user.auth && state.user.auth.role === ROLES.SUPERADMIN,
      isAdmin: (state) => state.user.auth && state.user.auth.role === ROLES.ADMIN,
      isSuperUser: (state) => state.user.auth && state.user.auth.role === ROLES.SUPERUSER,
      isCommonAdmin: (state) => state.user.auth && (state.user.auth.role === ROLES.ADMIN || state.user.auth.role === ROLES.SUPERADMIN),
      isUser: (state) => state.user.auth && (state.user.auth.role === ROLES.USER || state.user.auth.role === ROLES.EXTERNALUSER),
      auth: (state) => state.user.auth,
      hasAdminAccess: (state) => state.user.auth && (state.user.auth.role === ROLES.ADMIN || state.user.auth.role === ROLES.SUPERADMIN),
    }),
    isEditor: function () {
      return this.auth && (this.auth.role === ROLES.SUPERADMIN || this.auth.role === ROLES.ADMIN);
    },
  },
  methods: {
    ...mapActions({
      setAuth: 'user/setAuth',
      removeAuth: 'user/removeAuth',
    }),
    async checkRouteAuth() {
      if (this.$route.meta.requiresAuth && !this.authStorageService.isAuthenticated()) {
        await this.signOut();
      }
    },
    async signOut() {
      this.setAuth(null);
      await this.authService.signOut();
      this.goToSignIn();
    },
  },
  created: function () {
    this.authService = authService;
    this.authStorageService = authStorageService;
    const isAuthenticated = this.authStorageService.isAuthenticated();
    if (isAuthenticated) {
      const auth = this.authStorageService.getAuth();
      this.setAuth(auth);
    }
    // this.authCheckTimer = setInterval(this.checkRouteAuth, this.checkAuthInterval);
  },
  beforeDestroy: function () {
    if (this.authCheckTimer) {
      clearInterval(this.authCheckTimer);
      this.authCheckTimer = undefined;
    }
  },
};
